import styled from "@emotion/styled";
import React from "react";

import imageDownloadWhite from "../../../../public/img/icons/download-white.svg";
import imageUploadWhite from "../../../../public/img/icons/upload-white.svg";
import { formatSpeed } from "../../../helper/formatSpeeds";
import t from "../../../helper/t";

interface TariffInfoProps {
  bookedDownloadSpeed: number,
  bookedUploadSpeed: number,
}

const TariffContainer = styled.div([
  props => props.theme.colors.background.tertiary,
  {
    minHeight: 48,
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "center",
    gap: 8
  },
  `
  @media (min-width: 768px) {
    width: 500px;
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;
    margin: 0 auto;
  }
`]);

const TariffText = styled.div([
  props => props.theme.typography.tabletTitle,
  props => props.theme.colors.white,
  `
  margin-left: 8px;
  `
]);

const TariffInfo: React.FC<TariffInfoProps> = ({ bookedDownloadSpeed, bookedUploadSpeed }) => {
  return (
    <TariffContainer>
      <TariffText>{t("Dein Tarif")}</TariffText>
      <TariffInfoItem speed={bookedDownloadSpeed} iconSrc={imageDownloadWhite.src} caption={t("Download")} />
      <TariffInfoItem speed={bookedUploadSpeed} iconSrc={imageUploadWhite.src} caption={t("Upload")} />
    </TariffContainer>
  );
}

const TariffIcon = styled.div([
  `
    width: 30px;
    height: 30px;
    padding: 8px 4px;
    display: none;

    @media (min-width: 768px) {
      display: inline-block;
    }

    img {
      width: 28px;
      height: 28px;
    }
`
]);

const TariffValue = styled.div([
  props => props.theme.typography.regular32,
  props => props.theme.colors.white,
  `
    @media (min-width: 768px) {
      font-size: 36px
    }
  `
]);

const TariffValueText = styled.div([
  props => props.theme.typography.tariffValueText,
  props => props.theme.colors.white,
  `text-align: left; padding-left: 4px`
]);

const TextBold = styled.span([
  props => props.theme.typography.bold
]);

interface TariffInfoItemProps {
  speed: number;
  iconSrc: string;
  caption: string;
}
const TariffInfoItem: React.FC<TariffInfoItemProps> = ({ speed, iconSrc, caption }) => {
  const speedValues = formatSpeed([speed]);

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "0px" }}>
      <TariffIcon>
        <img src={iconSrc} alt={`icon-${caption.toLowerCase()}-white`} />
      </TariffIcon>
      <TariffValue data-cy={`um-tarif-text-${caption.toLowerCase()}-value`}>
        {speedValues.values[0]}
      </TariffValue>
      <TariffValueText>
        {speedValues.unit}
        <br />
        <TextBold>{caption}</TextBold>
      </TariffValueText>
    </div>
  )
};

export default TariffInfo;
